import React from 'react';
import { X, Download } from 'lucide-react';

const InquiryDrawer = ({ unit, onClose }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const name = form.elements[0].value;
    const email = form.elements[1].value;
    const message = form.elements[2].value;

    const subject = `Inquiry for Unit ${unit.id}`;
    const body = `Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`;

    const mailtoLink = `mailto:marketing@balebetrealestate.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink;
    
    onClose();
  };

  return (
    <div className="drawer">
      <X size={24} style={{ cursor: 'pointer', marginBottom: '20px' }} onClick={onClose} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>Inquiry</h2>
        <a href={unit.image} download={`Unit-${unit.id}-Floor-Plan.jpg`} style={{ textDecoration: 'none' }}>
          <button style={{ background: 'none', border: 'none', color: 'var(--olive)', display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
            <Download size={16} /> <small>Floor Plan</small>
          </button>
        </a>
      </div>
      <p>Regarding <strong>Unit {unit.id}</strong> (Floor {unit.floor})</p>
      
      <form onSubmit={handleSubmit}>
        <input type="text" placeholder="Full Name" required />
        <input type="email" placeholder="Email Address" required />
        <textarea rows="5" defaultValue={`I am interested in viewing the ${unit.type} on floor ${unit.floor}.`}></textarea>
        <button type="submit" className="btn-action" style={{ padding: '15px' }}>Submit Reservation Request</button>
      </form>
    </div>
  );
};

export default InquiryDrawer;
